import { decodeItemId, encodeItemId } from '../parsers/item-id';
import { ItemKind } from '../../../constants/ItemKind';
export function toItem(item, parentFolderId) {
  const {
    siteMediaToken
  } = decodeItemId(parentFolderId);
  return {
    ...item,
    kind: ItemKind.File,
    id: encodeItemId(siteMediaToken, item.id),
    folderId: parentFolderId,
    source: 'wixSite'
  };
}